import { useAuth as useClerkAuth, useUser } from '@clerk/clerk-react';

const BYPASS = import.meta.env.VITE_BYPASS_AUTH === 'true';

// Stable object — must not be created inside the hook or it re-triggers effects
const BYPASS_AUTH = BYPASS
  ? {
      getToken: async () => null,
      isSignedIn: true,
      role: 'admin',
      email: import.meta.env.VITE_BYPASS_AUTH_EMAIL || 'stephen@sitruna.com',
      isAdmin: true,
      isAM: false,
      isSpecialist: false,
      canEdit: true,
      user: { publicMetadata: { role: 'admin' } },
    }
  : null;

export function useAuth() {
  if (BYPASS) return BYPASS_AUTH;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { getToken, isSignedIn } = useClerkAuth();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { user } = useUser();

  const email = user?.primaryEmailAddress?.emailAddress || null;
  const meta = user?.publicMetadata || {};

  // Mirrors apps/api/src/middleware/auth.js attachUser():
  //   1. @sitruna.com → admin
  //   2. publicMetadata.organisation === 'sitruna' → admin
  //   3. publicMetadata.role
  //   4. read_only fallback
  let role;
  if (email && email.toLowerCase().endsWith('@sitruna.com')) {
    role = 'admin';
  } else if (meta.organisation === 'sitruna') {
    role = 'admin';
  } else {
    role = meta.role || 'read_only';
  }

  const isAdmin = role === 'admin';
  const isAM = role === 'account_manager';
  const isSpecialist = role === 'specialist';
  const canEdit = ['admin', 'account_manager', 'specialist'].includes(role);

  return {
    getToken,
    isSignedIn,
    role,
    email,
    isAdmin,
    isAM,
    isSpecialist,
    canEdit,
    user,
  };
}
